import React from 'react'
import ReactDOM from 'react-dom'
import { RouterProvider, useRoute } from 'react-router5'
import createRouter from 'router5'
import browserPlugin from 'router5-plugin-browser'
import App from './components/App.jsx'
import './index.css'
import './background'

const routes = [
  { name: 'home', path: '/' },
  { name: 'quiz_picker', path: '/quizzes' },
  { name: 'quiz', path: '/quizzes/:unit' },
  { name: 'quiz_question', path: '/quizzes/:unit/:question' },
  { name: 'quiz_submission', path: '/quizzes/:id/submission?seed' },
  { name: 'leaderboards', path: '/leaderboards' },
  { name: 'leaderboard', path: '/leaderboards/:id' },
  { name: 'settings', path: '/settings' },
]

const router = createRouter(routes)

router.usePlugin(browserPlugin())
router.start(`${location.pathname}${location.search}`, () => {
  ReactDOM.render(
    <RouterProvider router={router}>
      <App />
    </RouterProvider>,
    document.getElementById('pilota-root')
  )
})
